<template>
  <div class="profit-bill">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="overview">
        <div class="ring-out">
          <div class="ring-in">
            <div class="date">{{ info.incomeDate || '' }}收入(元)</div>
            <div class="amount">
              ￥{{ info.taxAllMoney || 0 | formatMoney }}
            </div>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="title">
          <i class="block"></i>
          分润收入明细
        </div>
        <div class="items">
          <div class="item">
            <div class="left">整体扫码交易笔数</div>
            <div class="right">{{ info.allSweepCodeNum || 0 }}笔</div>
          </div>
          <div class="item">
            <div class="left">整体扫码交易金额</div>
            <div class="right">
              ￥{{ info.allSweepCodeMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">整体信用卡交易笔数</div>
            <div class="right">{{ info.allWPCNum || 0 }}笔</div>
          </div>
          <div class="item">
            <div class="left">整体信用卡交易金额</div>
            <div class="right">￥{{ info.allWPCMoney || 0 | formatMoney }}</div>
          </div>
          <div class="item">
            <div class="left">整体借记卡交易笔数</div>
            <div class="right">{{ info.allWPDNum || 0 }}笔</div>
          </div>
          <div class="item">
            <div class="left">整体借记卡交易金额</div>
            <div class="right">￥{{ info.allWPDMoney || 0 | formatMoney }}</div>
          </div>
          <div class="item">
            <div class="left">自身扫码交易笔数</div>
            <div class="right">{{ info.selfSweepCodeNum || 0 }}笔</div>
          </div>
          <div class="item">
            <div class="left">自身扫码交易金额</div>
            <div class="right">
              ￥{{ info.selfSweepCodeMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">自身刷卡交易笔数</div>
            <div class="right">
              {{ info.selfWPCNum + info.selfWPDNum || 0 }}笔
            </div>
          </div>
          <div class="item">
            <div class="left">自身刷卡交易金额</div>
            <div class="right">
              ￥{{ info.selfWPCMoney + info.selfWPDMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">自身借记卡封顶交易笔数</div>
            <div class="right">{{ info.selfCapNum || 0 }}笔</div>
          </div>
          <div class="item">
            <div class="left">自身借记卡封顶交易金额</div>
            <div class="right">
              ￥{{ info.selfCapMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item special">
            <div class="left">下级整体扫码交易笔数</div>
            <div class="right">{{ info.subsetSweepCodeNum || 0 }}笔</div>
          </div>
          <div class="item special">
            <div class="left">下级整体扫码交易金额</div>
            <div class="right">
              ￥{{ info.subsetSweepCodeMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item special">
            <div class="left">下级整体刷卡交易笔数</div>
            <div class="right">
              {{ info.subsetWPCNum + info.subsetWPDNum || 0 }}笔
            </div>
          </div>
          <div class="item special">
            <div class="left">下级整体刷卡交易金额</div>
            <div class="right">
              ￥{{
                info.subsetWPCMoney + info.subsetWPDMoney || 0 | formatMoney
              }}
            </div>
          </div>
          <div class="item">
            <div class="left">扫码类交易分润比例</div>
            <div class="right">
              {{ info.sweepCodeRatio / 100 || 0 | formatMoney(3) }}%
            </div>
          </div>
          <div class="item">
            <div class="left">扫码类交易分润</div>
            <div class="right">
              ￥{{ info.sweepCodeMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">刷卡类交易分润比例</div>
            <div class="right">
              {{ (info.wpCRatio + info.wpDRatio) / 100 || 0 | formatMoney(3) }}%
            </div>
          </div>
          <div class="item">
            <div class="left">刷卡类交易分润</div>
            <div class="right">
              ￥{{ info.wpDMoney + info.wpCMoney || 0 | formatMoney }}
            </div>
          </div>
          <div class="item">
            <div class="left">借记卡达标交易分润</div>
            <div class="right">￥{{ info.wpDCapMoney || 0 | formatMoney }}</div>
          </div>
          <div class="item">
            <div class="left">皇冠比例</div>
            <div class="right">
              {{ info.crownRatio / 100 || 0 | formatMoney(3) }}%
            </div>
          </div>
          <div class="item">
            <div class="left">皇冠津贴</div>
            <div class="right">￥{{ info.crownMoney || 0 | formatMoney }}</div>
          </div>
          <div class="item special">
            <div class="left">分润总计</div>
            <div class="right">￥{{ info.allMoney || 0 | formatMoney }}</div>
          </div>
          <div class="item">
            <div class="left">分润税后</div>
            <div class="right">￥{{ info.taxAllMoney || 0 | formatMoney }}</div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { WSBridge, platformAgent, formatMoney, jiemi } from '@/utils/utils'
import { getWPIncome } from '@/api/profit/profit'
import { Toast } from 'vant'
export default {
  filters: {
    formatMoney
  },
  data() {
    return {
      info: {},
      isLoading: false,
      incomeId: this.$route.query.incomeId || '',
      frDate: this.$route.query.frDate
    }
  },
  created() {
    this.incomeId = parseInt(this.incomeId)
    console.log(this.incomeId, this.frDate)
    if (this.incomeId == '0' || this.incomeId == 0) {
      this.$router.replace({
        path: '/profit-bill-wp-revision',
        query: {
          frDate: this.frDate || '2021-09'
        }
      })
      return
    } else {
      this.init()
    }
  },
  methods: {
    init() {
      getWPIncome({
        action: 'getWPIncome',
        incomeId: this.incomeId
      }).then(result => {
        this.info = result || {}
        if (JSON.stringify(this.info) == '{}') {
          // Toast('未查到分润明细数据')
        }
      })
      return
      let result = WSBridge.nativeHttpEncrypt({
        params: {
          action: 'getWPIncome',
          incomeId: this.incomeId
        },
        success: res => {
          this.getEncryptParams(res)
        }
      })
      if (platformAgent() == 'android') {
        this.getEncryptParams(result)
      }
    },
    getEncryptParams(result) {
      if (typeof result == 'string') {
        result = JSON.parse(result)
      }
      let headers = result.headers
      if (typeof headers == 'string') {
        headers = JSON.parse(headers)
      }
      this.$store.commit('SET_QUERYS', headers)
      let body = result.body
      if (typeof body == 'string') {
        body = JSON.parse(body)
      }
      let token = result.token
      getWPIncome(body).then(
        res => {
          if (!res) {
            return
          }
          let params = token + '#' + JSON.stringify(res)
          let ret = WSBridge.nativeHttpDecrypt({
            params,
            success: res => {
              this.getDecryptResult(res)
            }
          })
          if (platformAgent() == 'android') {
            this.getDecryptResult(ret)
          }
        },
        err => {
          alert('err: ' + err)
        }
      )
    },
    getDecryptResult(result) {
      result = jiemi(result)
      if (typeof result == 'string') {
        result = JSON.parse(result)
      }
      this.info = result.data || {}
      if (JSON.stringify(this.info) == '{}') {
        Toast('未查到分润明细数据')
      }
    },
    onRefresh() {
      this.init()
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    }
  }
}
</script>
